import React from 'react'
import "./Contact.css"
import Iframe from  'react-iframe'

export default function Contact() {
  return (
    <div className='contact'>
       <div className='box green'><Iframe className='iframmap' url='https://www.google.com/maps/embed?pb=!1m24!1m8!1m3!1d42333.15921764267!2d73.0937225775879!3d33.67664769953503!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x38df954af2e02bd1%3A0xbbf6b742a174f9c2!2sFaizabad+Stop%2C+Islamabad!3m2!1d33.663159199999996!2d73.08527389999999!4m5!1s0x38dfeb84b6634521%3A0x8a99ddef6b57c77c!2sCentre+for+Bioresource+Research%2C+Jinnah+Avenue+2%2C+Al+Rehman+Vilas%2C+Bukhkari+chowk+New+Mal%2C+Islamabad%2C+Islamabad+Capital+Territory%2C+Pakistan!3m2!1d33.688262!2d73.1775238!5e1!3m2!1sen!2s!4v1565092640402!5m2!1sen!2s' width="600" height="450" frameborder="0" style="border:0" allowfullscreen styles={{display:"flex"}}></Iframe></div>
</div>
    
  )
}
